import { create } from "zustand"

const initialState = {
  areStudiesSelected: false,
}

const useProtocolMaintenanceStore = create((set) => ({
  ...initialState,
  setAreStudiesSelected: (areStudiesSelected) => set({ areStudiesSelected }),
}))

export default useProtocolMaintenanceStore
